import Axios from "../../api/Axios";
const BASE_URL = "PaytermCreditLimit/";
export const Endpoint = {
    CreditLimitUpload: "CreditLimitUpload",
    PaymentCreditDownload: "PaymentCreditDownload",
};

export const createAPIEndpointPayterm = () => {
    return { get: (Endpoint) => Axios.get(BASE_URL + Endpoint),
        post: (Endpoint,data)=> Axios.post(BASE_URL+Endpoint,data)
    };
};